module.exports = __webpack_public_path__ + "media/src/img/footer-deco-lh-e039176340725a5f545f5b46a8f071ea.svg";